import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'
import isDentalClinic from "@/middleware/isDentalClinic"

import PatientGeneral from "@/components/pages/patients/PatientGeneral"
import PatientDocuments from "@/components/pages/patients/PatientDocuments"
import PatientPersonal from "@/components/pages/patients/PatientPersonal"
import PatientComments from "@/components/pages/patients/PatientComments"
import PatientClientService from "@/components/pages/patients/PatientClientService"
import PatientNotifications from "@/components/pages/patients/PatientNotifications"

export default {
    path: '/patients/:id',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
    // component: () => import('../components/pages/patients/PatientGeneral.vue'),
    component: PatientGeneral,
    children: [
        { path: '', redirect: to => ({ name: 'PatientVisits', params: { id: to.params.id } }) },
        {
            path: 'visits', name: "PatientVisits",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            component: () => import('../components/pages/patients/PatientVisits.vue')
        },
        {
            path: 'visits/:visitid/:page', name: "PatientVisitPage",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            component: () => import('../components/pages/patients/PatientVisit.vue'),
        },
        {
            path: 'formula', name: "PatientFormula",
            meta: { middleware: [authorized, paid, isDentalClinic], layout: "default", rights: ['patient_card'] },
            component: () => import('../components/pages/patients/PatientFormula.vue')
        },
        {
            path: 'payments', name: "PatientPayments",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            component: () => import('../components/pages/patients/PatientPayments.vue')
        },
        {
            path: 'deposit', name: "PatientDepositTransactions",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card', 'deposit'] },
            component: () => import('../components/pages/patients/PatientDepositTransactions.vue')
        },
        {
            path: 'family_account', name: "PatientFamilyAccount",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card', 'family_account'] },
            component: () => import('../components/pages/patients/PatientFamilyAccount.vue')
        },
        {
            path: 'treatment_plan', name: "PatientTreatmentPlan",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card', 'planning'] },
            component: () => import('../components/pages/patients/PatientTreatmentPlan.vue')
        },
        {
            path: 'insurance', name: "PatientInsurancePolises",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            component: () => import('../components/pages/patients/PatientInsurancePolises.vue')
        },
        {
            path: 'scans', name: "PatientScans",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['scans','patient_card'] },
            component: () => import('../components/pages/patients/PatientScans.vue')
        },
        {
            path: 'notes', name: "PatientNotes",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            component: () => import('../components/pages/patients/PatientNotes.vue')
        },
        {
            path: 'documents', name: "PatientDocuments",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card', 'documents_upload'] },
            // component: () => import('../components/pages/patients/PatientDocuments.vue')
            component: PatientDocuments
        },
        {
            path: 'personal', name: "PatientPersonal",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            // component: () => import('../components/pages/patients/PatientPersonal.vue')
            component: PatientPersonal
        },
        {
            path: 'comments', name: "PatientComments",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            // component: () => import('../components/pages/patients/PatientComments.vue')
            component: PatientComments
        },
        {
            path: 'service', name: "PatientClientService",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            component: PatientClientService
        },
        {
            path: 'notifications', name: "PatientNotifications",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card'] },
            component: PatientNotifications
        },
        {
            path: 'tasks', name: 'PatientTasks',
            meta: { middleware: [authorized, paid], layout: "default" },
            component: () => import('../components/pages/patients/PatientTasks.vue')
        },
        {
            path: 'leads', name: 'PatientLeads',
            meta: { middleware: [authorized, paid], layout: "default" },
            component: () => import('../components/pages/patients/PatientLeads.vue')
        },
        {
            path: 'canban', name: 'PatientCanban',
            meta: { middleware: [authorized, paid], layout: "default" },
            component: () => import('../components/pages/patients/PatientCanban.vue')
        },
        {
            path: 'orders', name: "PatientLaboratoryOrders",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card', 'laboratories'] },
            component: () => import('../components/pages/patients/PatientLaboratoryOrders'),
        },
        {
            path: 'ndfl', name: "PatientNDFLs",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['ndfl_form'] },
            component: () => import('../components/pages/patients/PatientNDFLs.vue')
        },
        {
            path: 'diagnocat', name: 'PatientDiagnoCatStudies',
            meta: { middleware: [authorized, paid], layout: "default" },
            component: () => import('../components/pages/patients/PatientDiagnoCatStudies.vue')
        },
        {
            path: 'feedbacks', name: "PatientFeedbacks",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['patient_card', 'view_feedbacks'] },
            component: () => import('../components/pages/patients/PatientFeedbacks'),
        },
    ]
}
